import { AppDatePicker } from "../../core/AppDatePicker";
import { constantToDisplayName } from "../../core/constantToDisplayName";
import { useUserDateFormat } from "../../core/useFormatUserDate";
import { Formik } from 'formik';
import { AccessType } from 'legoland-sdk/dist/experimental';
import moment from 'moment';
import { useProductLimitDefaults } from "../productsHooks";
import { useState } from 'react';
import styled from 'styled-components';
import { Box, Button, FormGroup, Modal, RadioGroup, tombac, useToasts } from 'tombac';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { useAddAccessMutation } from "../../users/api/userManagementApiHooks";
import { object, string } from 'yup';
import { ProductModalHeader } from "./ProductModalHeader";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ModalWithOverflow = styled(Modal).withConfig({
  displayName: "AddAccessModal__ModalWithOverflow"
})(["overflow:visible;.TombacModalWindow{overflow:visible;}"]);
const Form = styled.form.withConfig({
  displayName: "AddAccessModal__Form"
})(["align-items:start;background-color:", ";display:grid;gap:", ";grid-template-areas:'access-type access-type' 'start-date end-date' 'actions actions';padding:", ";"], tombac.color.white, tombac.space(3, 5), tombac.space(2, 4, 3));
const validationSchema = object({
  accessType: string().ensure().trim().required('Please select an access type')
});
export const AddAccessModal = _ref => {
  let {
    isOpen,
    onRequestClose,
    onSuccess,
    productId,
    showCustomAgreementOption,
    showFreeOption,
    showInternalOption
  } = _ref;
  const defaultEvaluationLengthInDays = useProductLimitDefaults({
    accessType: AccessType.Evaluation,
    productId
  })?.defaultEvaluationLengthInDays;
  const dateFormat = useUserDateFormat();
  const {
    addToast
  } = useToasts();
  const [now] = useState(new Date());
  const user = useUserDetails();
  const {
    mutateAsync: addAccess
  } = useAddAccessMutation();
  const [options] = useState(Object.keys(AccessType).filter(k => (AccessType[k] !== AccessType.Internal || showInternalOption) && (AccessType[k] !== AccessType.Demo || showFreeOption) && (AccessType[k] !== AccessType.CustomAgreement || showCustomAgreementOption)).map(k => ({
    label: constantToDisplayName(AccessType[k]),
    value: AccessType[k]
  })));
  const handleSubmitAccess = async values => {
    try {
      await addAccess({
        expiryDate: moment.utc(values.endDate).startOf('day').toISOString(),
        productId,
        username: user.email,
        type: values.accessType
      });
      onSuccess();
    } catch (error) {
      const parsedError = await error.json();
      addToast(typeof parsedError === 'string' ? parsedError : parsedError?.message || 'An unexpected error occured. Please try again later.', 'danger');
    }
  };
  return /*#__PURE__*/_jsxs(ModalWithOverflow, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "ModalWithOverflow",
    "data-sentry-component": "AddAccessModal",
    "data-sentry-source-file": "AddAccessModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      onRequestClose: onRequestClose,
      productId: productId,
      subtitle: "Choose the access type and select dates to add a new access.",
      title: "Add new access",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "AddAccessModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), /*#__PURE__*/_jsx(Formik, {
      initialValues: {
        accessType: null,
        endDate: moment(new Date()).add(defaultEvaluationLengthInDays ?? 30, 'days').toDate()
      },
      onSubmit: values => handleSubmitAccess(values),
      validationSchema: validationSchema,
      "data-sentry-element": "Formik",
      "data-sentry-source-file": "AddAccessModal.tsx",
      "data-sentry-element": "Formik",
      children: _ref2 => {
        let {
          errors,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          values
        } = _ref2;
        return /*#__PURE__*/_jsxs(Form, {
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/_jsx(FormGroup, {
            error: errors.accessType,
            label: "Access type",
            style: {
              gridArea: 'access-type'
            },
            children: /*#__PURE__*/_jsx(RadioGroup, {
              onChange: option => {
                setFieldValue('accessType', option.value);
              },
              options: options,
              value: options.find(o => o.value === values.accessType),
              variant: "horizontal"
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            label: "Start date",
            style: {
              gridArea: 'start-date'
            },
            children: /*#__PURE__*/_jsx(AppDatePicker, {
              dateFormat: dateFormat,
              disabled: true,
              value: now
            })
          }), /*#__PURE__*/_jsx(FormGroup, {
            error: errors.endDate,
            label: "End date",
            style: {
              gridArea: 'end-date'
            },
            children: /*#__PURE__*/_jsx(AppDatePicker, {
              dateFormat: dateFormat,
              maxDate: moment.utc().add(10, 'years').toDate(),
              minDate: moment.utc().startOf('day').toDate(),
              onChange: date => setFieldValue('endDate', date),
              value: values.endDate
            })
          }), /*#__PURE__*/_jsxs(Box, {
            $ml: "auto",
            $mt: "2sp",
            style: {
              gridArea: 'actions'
            },
            children: [/*#__PURE__*/_jsx(Button, {
              onClick: onRequestClose,
              type: "button",
              variant: "flat",
              children: "Cancel"
            }), /*#__PURE__*/_jsx(Button, {
              busy: isSubmitting,
              $ml: "1sp",
              type: "submit",
              variant: "primary",
              children: "Confirm access"
            })]
          })]
        });
      }
    })]
  });
};